<template>
  <div class="NeighbourNewMsg">
    <van-nav-bar fixed border class="msgnav">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
        <span>消息</span>    
      </template>
    </van-nav-bar>
    <div class="msglist">
    <div class="msgdel" v-for="(item,index) in totalList " :key="index">
         <div v-if="item.status == 7" class="content"> 
           <div class="infomsg">
             <img class="newhead" :src="attach_url+item.comment.user.u_headportrait" alt=""/>
             <div class="detail">
              <p class="name">{{item.comment.user.u_nickname?item.comment.user.u_nickname:item.comment.user.u_name?item.comment.user.u_name:item.comment.user.u_login_id}}</p>
              <p class="content">{{item.comment.content}}</p>
             <p class="time">{{item.comment.create_time}}</p>
             </div>
           </div>
          <div class="circlecnt">
           <img v-if="item.message.picture!==''&& item.message.picture !=='undefined'&&item.message.picture.indexOf('.mp4') == -1 && item.message.picture.indexOf('.jpeg') == -1" :src="attach_url+item.message.picture" alt=""> 
            <img v-else-if="item.message.picture!==''&& item.message.picture !=='undefined'&&item.message.picture.indexOf('.jpeg') != -1"  :src="attach_url+item.message.picture.substring(0,37)" alt=""> 
            <div v-else-if="item.message.picture!== 'undefined' && item.message.picture.indexOf('.mp4') != -1">
            <img class="videocover" :src="attach_url+item.message.picture.replace('mp4', 'jpg')" alt />
            <img class="playbtn" src="../../assets/play.png"/>
           </div>
           <p v-else  class="circletxt">{{item.message.content}}</p>
          </div>
          </div>
          <div v-else-if="item.status == 6"  class="content">
           <div class="infomsg">
            <img class="newhead" :src="attach_url+item.userinfo.u_headportrait" alt=""/>
            <div class="detail">
             <p class="name">{{item.userinfo.u_nickname?item.userinfo.u_nickname:item.userinfo.u_name?item.userinfo.u_name:item.userinfo.u_login_id}}</p>
             <img style="width:15px;height:15px;" class="likeicon" src="../../assets/img/center/like.png" alt />
             <p class="time">{{item.time}}</p>
            </div>
           </div>
            <div class="circlecnt">
           <img v-if="item.message.picture!==''&& item.message.picture !=='undefined'&&item.message.picture.indexOf('.mp4') == -1" style="width:80px;height:80px;" :src="attach_url+item.message.picture" alt=""> 
            <div v-else-if="item.message.picture!== 'undefined' && item.message.picture.indexOf('.mp4') != -1">
            <img class="videocover" style="height:80px;width:80px;" :src="attach_url+item.message.picture.replace('mp4', 'jpg')" alt />
            <img class="playbtn" src="../../assets/play.png"/>
           </div>
           <p v-else  class="circletxt">{{item.message.content}}</p>
          </div>
          </div>
          </div>
      </div> 
   </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: "NeighbourNewMsg",
  data() {
    return {
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      newMsgShow:"",
      msgshowLists:JSON.parse(localStorage.getItem("msgshowLists")),
      newmsgList:JSON.parse(localStorage.getItem("newmsgList")), 
      msgList:JSON.parse(localStorage.getItem("msgList")),
      totalList:[],
    };
  },
  created() {
		this.getStateConfigs();
	this.gettotalList();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    goBack() {
         this.msgshowLists=[];
        localStorage.setItem("msgshowLists", JSON.stringify(this.msgshowLists));
        this.newmsgList=[];
         localStorage.setItem("newmsgList", JSON.stringify(this.newmsgList));
         this.msgList=[];
        localStorage.setItem("msgList", JSON.stringify(this.msgList));
        this.$router.push({
          path: "/NeighbourMoments",
           query:{
          msgstatus:1,
          }
      });
    },
    gettotalList(){
      for(var i in this.msgshowLists){
        this.totalList.push(this.msgshowLists[i]);
      }
      for(var i in this.msgList){
        this.totalList.push(this.msgList[i]);
      }

    }
    
  },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/My/NeighbourNewMsg.vue